import { FunctionComponent, SVGProps } from "react";
import { Button } from "components/Button/Button";
import { useExternalUrls } from "hooks/useExternalUrls";
import { useNavigate } from "react-router-dom";
import { ButtonAction, ButtonVariant } from "utils/trading/enums";

interface PrimaryActionButtonProps {
  action: ButtonAction;
  label: string;
  variant: ButtonVariant;
  size?: "xs" | "md";
  isFullWidth?: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  LeftIcon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const PrimaryActionButton = ({
  action,
  label,
  variant,
  size = "xs",
  isFullWidth = true,
  isLoading = false,
  disabled = false,
  LeftIcon,
  onClick,
}: PrimaryActionButtonProps) => {
  const navigate = useNavigate();
  const { fillTest, exchangeUrl } = useExternalUrls();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    switch (action) {
      case ButtonAction.CALL_TO_BROKER:
        navigate("/contact");
        break;

      case ButtonAction.FILL_THE_TEST:
        if (fillTest) {
          window.location.replace(fillTest);
        }
        break;

      case ButtonAction.EXCHANGE:
        if (exchangeUrl) {
          window.open(exchangeUrl, "_blank");
        }
        break;

      case ButtonAction.BUY:
      case ButtonAction.SUBSCRIPTION:
        if (onClick) {
          onClick(e);
        }
        break;

      default:
        if (onClick) {
          onClick(e);
        }
    }
  };

  return (
    <Button
      variant={isLoading ? "Transparent" : variant}
      size={size}
      isFullWidth={isFullWidth}
      isLoading={isLoading}
      disabled={disabled}
      onClick={handleClick}
      LeftIcon={LeftIcon}
    >
      {isLoading ? "" : label}
    </Button>
  );
};
